import { Platform } from 'react-native';
// eslint-disable-next-line import/no-cycle
import MonitoringLogger from './MonitoringLogger';
import { genericTenantLogBuilder } from './LogBuilders';
import LogLevel from '../../../logging/LogLevel';
let levelSuffix;
const logLevelSuffix = (level) => {
    switch (level) {
        case LogLevel.Error: {
            levelSuffix = '[ERROR]';
            break;
        }
        case LogLevel.Warn: {
            levelSuffix = '[WARN]';
            break;
        }
        case LogLevel.Info: {
            levelSuffix = '[INFO]';
            break;
        }
        case LogLevel.Debug: {
            levelSuffix = '[DEBUG]';
            break;
        }
        default: break;
    }
    return levelSuffix;
};
const AZLogTenant = (level, message, tenantId, optionalParams) => {
    if (level === null || !message || !tenantId) {
        return;
    }
    levelSuffix = logLevelSuffix(level);
    const msg = `${levelSuffix} ${message}`;
    const logObject = { message: msg, tenantId };
    if (Platform.OS === 'web') {
        logObject.platform = 'Web';
    }
    if (optionalParams) {
        if (typeof optionalParams !== 'object' || optionalParams === null) {
            return;
        }
        Object.entries(optionalParams).forEach(([key, value]) => {
            logObject[key] = value instanceof Error ? value.toString() : value;
        });
    }
    MonitoringLogger.write(genericTenantLogBuilder, logObject);
};
export { AZLogTenant, logLevelSuffix };
//# sourceMappingURL=LoggingSupport.js.map